<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout
    fluid
    column
    class="pa-0 ma-0 business-category-view"
    align-center
    justify-content
  >
    <page-title title="Business category"></page-title>
    <BizCategorySelection :campaign="{ ...$store.getters['user/currentCampaign'], 
      category: $store.getters['user/currentProject'].category}" 
      readonly></BizCategorySelection>
    
  </v-layout>
</template>

<script>
import BizCategorySelection from '@/components/survey/BizCategorySelection'

export default {
  name: 'TeamView',
  components: {  BizCategorySelection }
}
</script>

<style lang="stylus">
.business-category-view {
    }
</style>
